import mainRoute from '@input-web/modules/main/views/main/main.route';
import { createRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import {
  StandardListFilterSchema,
  standardListFilterSchema,
} from '../../models/standard-list-filter.model';
import StandardLayoutView from './standard-layout.view';

const standardLayoutRoute = createRoute({
  component: StandardLayoutView,
  getParentRoute: () => mainRoute,
  id: 'standard-layout',
  validateSearch: {
    ...zodValidator(standardListFilterSchema),
    parse: (input: StandardListFilterSchema) => standardListFilterSchema.safeParse(input).data,
  },
});

export default standardLayoutRoute;
